import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { QRCodeCanvas } from "qrcode.react"; // <-- from npm install qrcode.react

// Change the import to your new enterpriseaigroup.com logo image:
import enterpriseLogo from "./assets/enterpriseaigroup-logo.svg";

function HomePage() {
    const { t } = useTranslation();

    // Update the page title
    useEffect(() => {
        document.title = "ADAPTOVATE EAI Demonstrations"; // Change tab title
    }, []);

    return (
        <div className="flex min-h-screen flex-col bg-gray-100 text-gray-900">
            {/* Centered, larger EnterpriseAI logo moved closer to the top */}
            <div className="mt-4 flex w-full justify-center">
                <img
                    src={enterpriseLogo}
                    alt="Enterprise AI Group Logo"
                    className="w-72" // Slightly reduced size for better spacing
                />
            </div>

            <main className="flex flex-grow flex-col items-center justify-center text-center">
                {/* 1) ADAPTOVATE EAI Base Demonstration */}
                <div className="mt-1 flex flex-col items-center">
                    {" "}
                    {/* Reduced whitespace */}
                    <p className="mb-2 text-2xl font-extrabold text-blue-700">ADAPTOVATE EAI Base Demonstration</p>
                    {/* First QR code -> https://sgdemo.adaptovate.ai/basedemo */}
                    <QRCodeCanvas
                        value="https://sgdemo.adaptovate.ai/basedemo"
                        size={150}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="M"
                        includeMargin={false}
                        className="shadow-xl"
                    />
                    <p className="mt-2">
                        Or{" "}
                        <a href="https://sgdemo.adaptovate.ai/basedemo" className="text-blue-600 underline" rel="noopener noreferrer">
                            click here
                        </a>
                    </p>
                </div>
                {/* 2) ADAPTOVATE EAI Procurement1 Demonstration */}
                <div className="mt-1 flex flex-col items-center">
                    {" "}
                    {/* Reduced whitespace */}
                    <p className="mb-2 text-2xl font-extrabold text-blue-700">ADAPTOVATE EAI Procurement1 Demonstration</p>
                    {/* First QR code -> https://sgdemo.adaptovate.ai/p1demo */}
                    <QRCodeCanvas
                        value="https://sgdemo.adaptovate.ai/p1demo"
                        size={150}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="M"
                        includeMargin={false}
                        className="shadow-xl"
                    />
                    <p className="mt-2">
                        Or{" "}
                        <a href="https://sgdemo.adaptovate.ai/p1demo" className="text-blue-600 underline" rel="noopener noreferrer">
                            click here
                        </a>
                    </p>
                </div>
                {/* 1) ADAPTOVATE EAI Procurement2 Demonstration */}
                <div className="mt-1 flex flex-col items-center">
                    {" "}
                    {/* Reduced whitespace */}
                    <p className="mb-2 text-2xl font-extrabold text-blue-700">ADAPTOVATE EAI Procurement2 Demonstration</p>
                    {/* First QR code -> https://sgdemo.adaptovate.ai/p2demo */}
                    <QRCodeCanvas
                        value="https://sgdemo.adaptovate.ai/p2demo"
                        size={150}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="M"
                        includeMargin={false}
                        className="shadow-xl"
                    />
                    <p className="mt-2">
                        Or{" "}
                        <a href="https://sgdemo.adaptovate.ai/p2demo" className="text-blue-600 underline" rel="noopener noreferrer">
                            click here
                        </a>
                    </p>
                </div>

                {/* 1) ADAPTOVATE EAI Procurement3 Demonstration */}
                <div className="mt-1 flex flex-col items-center">
                    {" "}
                    {/* Reduced whitespace */}
                    <p className="mb-2 text-2xl font-extrabold text-blue-700">ADAPTOVATE EAI Procurement 3 Demonstration</p>
                    {/* First QR code -> https://sgdemo.adaptovate.ai/basedemo */}
                    <QRCodeCanvas
                        value="https://sgdemo.adaptovate.ai/p3demo"
                        size={150}
                        bgColor="#FFFFFF"
                        fgColor="#000000"
                        level="M"
                        includeMargin={false}
                        className="shadow-xl"
                    />
                    <p className="mt-2">
                        Or{" "}
                        <a href="https://sgdemo.adaptovate.ai/p3demo" className="text-blue-600 underline" rel="noopener noreferrer">
                            click here
                        </a>
                    </p>
                </div>
            </main>
            {/* adding in a comment to test the commit */}

            <footer className="py-2 text-center">
                <p>{t("app.footer")}</p>
            </footer>
        </div>
    );
}

export default HomePage;
